import React from 'react'

export default function Ert(props){
    let words = props.words
    const ert = Math.round(words / 250) + ' minutes'

    return <span>{ert}</span>
}